module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 326
// module chunks = 12